import { FC } from 'react';
import {
  Autocomplete,
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { menuItemStyles } from '@utils/styles';
import { Filter } from './types';
import appMagicLogo from '../../../../assets/icons/appmagic-yellow-logo.svg';
interface AdImpressionsFiltersProps {
  filters: Filter[];
  handleFilterChange: (key: string, selectedValue: string) => void;
  selections: Record<string, string>;
}

const AdImpressionsFilters: FC<AdImpressionsFiltersProps> = ({
  filters,
  handleFilterChange,
  selections,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        width: '100%',
        height: 'fit-content',
        borderRadius: '1.25rem',
        backgroundColor: '#FFFFFF',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: isMobile ? 'column' : 'row',
        gap: '1.25rem',
        padding: '1rem',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: 'fit-content',
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: '1.25rem',
        }}
      >
        {filters
          .sort((a, b) => a.key.localeCompare(b.key))
          .map((filter) => (
            <FormControl key={filter.key} sx={{ width: isMobile ? '100%' : '30%' }}>
              {filter.key !== 'country' && (
                <InputLabel id={`${filter.key}-label`}>{filter.label}</InputLabel>
              )}
              {filter.key === 'country' ? (
                <Autocomplete
                  id={`${filter.key}-autocomplete`}
                  options={filter.values}
                  getOptionLabel={(option) => option.label}
                  value={filter.values.find((opt) => opt.label === selections[filter.key])}
                  onChange={(_, value) => handleFilterChange(filter.key, value ? value.label : '')}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={filter.label}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      sx={{ height: '56px' }}
                    />
                  )}
                  disableClearable
                />
              ) : (
                <Select
                  labelId={`${filter.key}-label`}
                  label={filter.label}
                  value={selections[filter.key]}
                  onChange={(e) => handleFilterChange(filter.key, e.target.value)}
                  fullWidth
                  sx={{
                    height: '56px',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: '25rem',
                      },
                    },
                  }}
                >
                  {filter.values.map((option) => (
                    <MenuItem key={option.id} value={option.id} sx={menuItemStyles}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
            </FormControl>
          ))}
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          fontSize: '0.75rem',
          lineHeight: '1rem',
          color: '#162936',
          fontWeight: 500,
          alignItems: 'center',
          paddingRight: '1.25rem',
        }}
      >
        in partnership with
        <img
          src={appMagicLogo}
          alt="App Magic Logo"
          style={{ marginTop: '0.25rem', height: '44px' }}
        />
      </Box>
    </Box>
  );
};

export default AdImpressionsFilters;
